/*LIBRARY*/
import { useState, useEffect, useRef, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

/*COMPONENT*/
import Modal from "../common_modal/Modal";
import ModalNotification from "../common_modal/ModalNotification";
import ModalSearch from "../common_modal/ModalSearch";
import NotificationList from "./NotificationList";
import Login from "../auth/Login";
import Register from "../auth/Register";
import ModalEmailConfirm from "../common_modal/ModalEmailConfirm";
import WhatsappConfirm from "./WhatsappConfirm";
import PaymentTable from "../payment/PaymentTable";
import RedeemPopup from "../payment/RedeemPopup";

/*REDUX*/
import {
  refreshSearch,
  searchLayersOnly,
  searchProjects,
  searchGroups,
} from "../../App/actions/layerActions";
import { get_project_only } from "../../App/actions/projectActions";
import { setLanguage, set_value_user } from "../../App/actions/authActions";
import { set_value_properties } from "../../App/actions/propertiesActions";
import { set_value_sini } from "../../App/actions/sini_v2";

/*PICTURE*/
import icon_notification from "../../Assets/svg/icon_notification.svg";
import icon_map_editor from "../../Assets/svg/icon_map_editor.svg";
import icon_analyze_lite from "../../Assets/svg/icon_analyze_lite.svg";
import icon_form from "../../Assets/svg/icon_form_menu.svg";
import icon_group from "../../Assets/svg/icon_group.svg";
import icon_home from "../../Assets/svg/icon_home.svg";
import icon_profile from "../../Assets/svg/icon_profile.svg";
import icon_public_data from "../../Assets/svg/icon_public_data.svg";
import icon_trash from "../../Assets/svg/icon_delete_grey.svg";
import icon_hamburger from "../../Assets/svg/icon_hamburger.svg";
import SINI_ILUSTRATION from "../../Assets/jsx/SINI_ILUSTRATION";
import icon_search from "../../Assets/svg/search.svg";
import icon_delete_account from "../../Assets/svg/delete_account.svg";
import icon_flood_analysis_system from "../../Assets/svg/icon_system_analisa_banjir.svg";

/*FUNCTION*/
import formatDate from "../../App/validation/format-date";

/*DATA*/
import dict from "../../Data/dict.json";
import domain_list from "../../Data/domain_list";
import MENU_SEARCH_PROJECT from "../project_dashboard/MENU_SEARCH_PROJECT";
import Pricing from "../payment/Pricing";
import {
  create_payment,
  set_value_payment,
} from "../../App/actions/paymentActions";
import PROJECT_COLLAB from "../project_dashboard/PROJECT_COLLAB";
import PricingKetengan from "../payment/PricingKetengan";
import ErrorFreeKai from "../user/ErrorFreeKai";

/*CONST*/
const WAIT_INTERVAL = 1500;
const ENTER_KEY = 13;

const Navigation = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const auth = useSelector((state) => state.auth);
  const layer = useSelector((state) => state.layer);
  const properties = useSelector((state) => state.properties);
  const sini = useSelector((state) => state.sini);
  const payment_reducer = useSelector((state) => state.payment);

  const {
    domain,
    isAuthenticated,
    pathname,
    version,
    last_update,
    user,
    modal_login,
    modal_payment_universal,
    modal_block_license_universal,
    modal_ketengan_universal,
    language: reduxLanguage,
  } = auth;

  const { modal_buy_license } = properties;
  const { search_result_list, loadingProcess, itemLoading } = layer;
  const { geo_layer_list, geo_project_list, group_list, is_fresh } =
    search_result_list;
  const { modal_sini_ai_trial } = sini;

  const [width, set_width] = useState(window.innerWidth);
  const [search_params, set_search_params] = useState("");
  const [mode_search, set_mode_search] = useState("layer");
  const [project_selected, set_project_selected] = useState({});
  const [layer_selected, set_layer_selected] = useState({});
  const [mode_auth, set_mode_auth] = useState("login");
  const [modal_notification, set_modal_notification] = useState(false);
  const [modal_whatsapp, set_modal_whatsapp] = useState(true);
  const [modal_search, set_modal_search] = useState(false);
  const [modal_push_member, set_modal_push_member] = useState(false);
  const [modal_project, set_modal_project] = useState(false);
  const [is_menu_sidebar_open, set_is_menu_sidebar_open] = useState(false);
  const allowedUsernameListForDeleteAccount = ["dsdajakarta", "pusdatin_SDA"];

  const timer_ref = useRef(null);

  const triggerChange = useCallback(() => {
    if (search_params) {
      switch (mode_search) {
        case "layer":
          dispatch(searchLayersOnly(search_params));
          break;
        case "project":
          dispatch(searchProjects(search_params));
          break;
        case "group":
          dispatch(searchGroups(search_params));
          break;
        default:
          dispatch(searchLayersOnly(search_params));
          break;
      }
    }
  }, [search_params, mode_search, dispatch]);

  useEffect(() => {
    const handleWindowSizeChange = () => set_width(window.innerWidth);
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
      if (timer_ref.current) clearTimeout(timer_ref.current);
    };
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const payment_type = params.get("payment_type");
    const is_partial = params.get("is_partial");

    if (payment_type && !is_partial) {
      dispatch(set_value_user("modal_payment_universal", true));
    } else if (payment_type && is_partial) {
      dispatch(set_value_user("modal_block_sini_ai_sini_data", true));
    }
  }, [location.search, dispatch]);

  useEffect(() => {
    set_modal_project(false);
    set_modal_notification(false);
    set_modal_search(false);
  }, [pathname]);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(set_value_user("modal_login", false));
    }
  }, [isAuthenticated, dispatch]);

  const toggle_modal_push_member = (link) => {
    set_modal_push_member(!modal_push_member);
    if (link && typeof link === "string") {
      dispatch(get_project_only(link));
    }
  };

  const toggle_sini_ai_trial = () => {
    dispatch(
      set_value_sini({
        key: "modal_sini_ai_trial",
        value: !modal_sini_ai_trial,
      }),
    );
  };

  const toggle_payment_universal = () => {
    const { payment, is_able_to_greeting_page } = payment_reducer || {};
    const { is_sandbox, status } = payment || {};

    if (
      modal_payment_universal &&
      status === "success" &&
      is_able_to_greeting_page
    ) {
      const url = is_sandbox
        ? "https://staging.mapid.co.id/greetings/personal_license"
        : "https://mapid.co.id/greetings/personal_license";
      window.open(url, "_blank");
    }

    dispatch(
      set_value_user("modal_payment_universal", !modal_payment_universal),
    );
    dispatch(
      set_value_payment({ key: "is_able_to_greeting_page", value: false }),
    );
  };

  const toggle_modal_block_license_universal = () => {
    dispatch(
      set_value_user(
        "modal_block_license_universal",
        !modal_block_license_universal,
      ),
    );
  };

  const toggle_modal_modal_ketengan_universal = () => {
    dispatch(
      set_value_user("modal_ketengan_universal", !modal_ketengan_universal),
    );
  };

  const toggle_buy_license = () => {
    dispatch(
      set_value_properties({
        key: "modal_buy_license",
        value: !modal_buy_license,
      }),
    );
  };

  const toggle_login = () => {
    dispatch(set_value_user("modal_login", !modal_login));
  };

  const onSetLanguage = (lang) => {
    dispatch(setLanguage(lang));
  };

  const toggleProject = (selectedProject, selectedLayer) => {
    if (selectedProject?.link) set_project_selected(selectedProject);
    if (selectedLayer?.link) set_layer_selected(selectedLayer);
    set_modal_project(!modal_project);
  };

  const onChangeMode = (mode) => {
    if (timer_ref.current) clearTimeout(timer_ref.current);
    set_mode_search(mode);
  };

  const toggleSearch = () => {
    dispatch(refreshSearch());
    set_modal_search(!modal_search);
  };

  const activateSearch = () => {
    set_modal_search(true);
  };

  const closeSearch = () => {
    dispatch(refreshSearch());
    set_modal_search(false);
    set_modal_project(false);
  };

  const toggleNotification = () => {
    set_modal_notification(!modal_notification);
  };

  const toggle_is_menu_sidebar_open_func = () => {
    set_is_menu_sidebar_open(!is_menu_sidebar_open);
  };

  const toggleWhatsappConfirm = () => {
    set_modal_whatsapp(!modal_whatsapp);
  };

  const handleChange = (e) => {
    set_modal_search(true);
    const value = e.target.value;
    set_search_params(value);

    if (timer_ref.current) clearTimeout(timer_ref.current);
    timer_ref.current = setTimeout(triggerChange, WAIT_INTERVAL);
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === ENTER_KEY) {
      triggerChange();
    }
  };

  // local storage
  const language = localStorage?.language || reduxLanguage;

  // content
  const is_login_kai = domain_list?.[domain]?.is_login_kai;
  const env = domain_list?.[domain]?.env;
  const is_mobile = width <= 900;
  const premium_status = domain_list?.[domain]?.status;
  const is_hide_insight = domain_list?.[domain]?.is_hide_insight;
  const is_confirmed =
    !(user?.is_email_confirm !== "not_propose") &&
    !(user?.is_whatsapp_confirm !== "not_propose");

  let array_menu = [
    {
      title: dict["Dashboard"][language],
      icon: icon_home,
      link: "/dashboard",
      links: ["/dashboard"],
    },
    {
      title: dict["Profile"][language],
      icon: icon_profile,
      link: "/user_profile",
      links: ["/user_profile", "/purchase_list"],
    },
    {
      title: dict["Collaboration"][language],
      icon: icon_group,
      link: "/user_group/collaborator",
      links: ["/user_group/collaborator"],
    },
    {
      title: dict["Public Data"][language],
      icon: icon_public_data,
      link: "/",
      links: [
        "/",
        "/publication_free",
        "/publication_paid",
        "/publication_project",
      ],
    },
  ];

  let array_menu_public = [
    {
      title: dict?.["Login"]?.[language],
      icon: icon_profile,
      link: "/login",
      links: ["/login"],
    },
    {
      title: dict?.["Public Data"]?.[language],
      icon: icon_public_data,
      link: "/",
      links: [
        "/",
        "/publication_free",
        "/publication_paid",
        "/publication_project",
      ],
    },
  ];

  if (premium_status === "premium") {
    array_menu = [
      {
        title: dict["Dashboard"][language],
        icon: icon_home,
        link: "/dashboard",
        links: ["/dashboard"],
      },
      {
        title: dict["Profile"][language],
        icon: icon_profile,
        link: "/user_profile",
        links: ["/user_profile"],
      },
      {
        title: dict["Group"][language],
        icon: icon_group,
        link: "/user_group/collaborator",
        links: ["/user_group/collaborator"],
      },
    ];
    array_menu_public = [
      {
        title: dict["Login"][language],
        icon: icon_profile,
        link: "/login",
        links: ["/login"],
      },
    ];
  }

  if (
    [
      "localhost:3003",
      "dsdajakarta.mapid.io",
      "dsdajakarta-alpha.mapid.io",
      "dsdajakarta-beta.mapid.io",
    ].includes(domain)
  ) {
    if (allowedUsernameListForDeleteAccount.includes(user?.name)) {
      array_menu.push({
        title: dict["Delete Account"][language],
        icon: icon_delete_account,
        link: "/delete_account",
        links: ["/delete_account"],
      });
    }
    array_menu.push({
      title: dict["Flood Analysis System"][language],
      icon: icon_flood_analysis_system,
      link: "/flood_analysis_system",
      links: ["/flood_analysis_system"],
    });
  }

  if (is_hide_insight === true) {
    array_menu = array_menu.filter((data) => data.link !== "/insight");
  }

  let array_menu_final = isAuthenticated ? array_menu : array_menu_public;

  const mode_array = [
    { name: dict["Layer"][language], key: "layer" },
    { name: dict["Project"][language], key: "project" },
    { name: dict["Group"][language], key: "group" },
  ];

  let list_result;
  if (
    loadingProcess &&
    ["search_layer", "search_projects", "search_groups"].includes(itemLoading)
  ) {
    list_result = <div>{dict["Searching"][language]}...</div>;
  } else if (mode_search === "layer") {
    if (geo_layer_list.length === 0 && !is_fresh) {
      list_result = (
        <div className="text_medium sub_color">
          {
            dict["There are no layers with the keyword you are looking for"][
              language
            ]
          }
        </div>
      );
    } else if (is_fresh) {
      list_result = (
        <div className="text_medium sub_color">
          {
            dict[
              "Start looking for layers with the keywords you want to search for"
            ][language]
          }
        </div>
      );
    } else {
      list_result = (
        <div>
          {geo_layer_list.map((layer_item) => {
            const {
              _id,
              name,
              type,
              geo_project,
              user: layer_user,
              date,
            } = layer_item;
            const geo_project_name =
              geo_project?.name || dict["Project already delete"][language];
            const user_name =
              layer_user?.full_name || layer_user?.name || "No user";
            return (
              <main key={_id} className="result_item">
                <section className="result_name">{name}</section>
                <section
                  onClick={() => toggleProject(geo_project, layer_item)}
                  className="button background_black"
                >
                  {dict["Open"][language]} {dict["Project"][language]}:{" "}
                  <b>{geo_project_name}</b>
                </section>
                <br />
                <section className="badge_normal">
                  {dict["Type"][language]}: <b>{type}</b>
                </section>
                <section className="badge_normal">
                  {dict["Owner"][language]}: <b>{user_name}</b>
                </section>
                <section className="badge_normal">
                  {dict["Update at"][language]}: <b>{formatDate(date)}</b>
                </section>
              </main>
            );
          })}
        </div>
      );
    }
  } else if (mode_search === "project") {
    if (geo_project_list.length === 0 && !is_fresh) {
      list_result = (
        <div className="text_medium sub_color">
          {
            dict["There are no projects with the keywords you are looking for"][
              language
            ]
          }
        </div>
      );
    } else if (is_fresh) {
      list_result = (
        <div className="text_medium sub_color">
          {
            dict[
              "Start searching for projects with the keywords you want to search"
            ][language]
          }
        </div>
      );
    } else {
      list_result = (
        <main>
          {geo_project_list.map((project) => {
            const { _id, name, user: project_user, date } = project;
            const user_name =
              project_user?.full_name || project_user?.name || "No user";
            return (
              <main key={_id} className="result_item">
                <section
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div
                    style={{ cursor: "default" }}
                    className="result_name text_medium"
                  >
                    {name}
                  </div>
                  <MENU_SEARCH_PROJECT
                    project={project}
                    toggleSearch={toggleSearch}
                    toggle_modal_push_member={toggle_modal_push_member}
                  />
                </section>
                <section
                  onClick={() => toggleProject(project)}
                  className="button background_black"
                >
                  {dict["Open"][language]} {dict["Project"][language]}
                </section>
                <br />
                <section className="badge_normal">
                  {dict["Owner"][language]}: <b>{user_name}</b>
                </section>
                <section className="badge_normal">
                  {dict["Update at"][language]}: <b>{formatDate(date)}</b>
                </section>
              </main>
            );
          })}
        </main>
      );
    }
  } else {
    if (group_list.length === 0 && !is_fresh) {
      list_result = (
        <div className="text_medium sub_color">
          {
            dict["There are no groups with the keyword you are looking for"][
              language
            ]
          }
        </div>
      );
    } else if (is_fresh) {
      list_result = (
        <div className="text_medium sub_color">
          {
            dict[
              "Start searching for groups with the keywords you want to search"
            ][language]
          }
        </div>
      );
    } else {
      list_result = (
        <div>
          {group_list.map(({ _id, name, members, date }) => (
            <main key={_id} className="result_item">
              <Link
                to={`/group/${_id}`}
                className="result_name"
                onClick={closeSearch}
              >
                {name}
              </Link>
              <br />
              <Link
                to={`/group/${_id}`}
                onClick={closeSearch}
                className="button background_black"
              >
                {dict["Open"][language]} {dict["Group"][language]}
              </Link>
              <br />
              <section className="badge_normal">
                {dict["Members"][language]}: <b>{members.length}</b>
              </section>
              <section className="badge_normal">
                {dict["Create at"][language]}: <b>{formatDate(date)}</b>
              </section>
            </main>
          ))}
        </div>
      );
    }
  }

  const search_result_content = modal_search && (
    <ModalSearch
      modalSize="small"
      id="modal"
      isOpen={modal_search}
      onClose={toggleSearch}
    >
      <div className="box-body">
        <div>
          <input
            autoFocus
            type="text"
            placeholder={dict["Search your layer, project or group"][language]}
            autoComplete="off"
            name="search_params"
            value={search_params}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            onFocus={activateSearch}
          />
        </div>
        <br />
        <section className="margin_bottom">
          {mode_array.map((e) => {
            const css_id =
              mode_search === e.key ? "background_black" : "button_white";
            return (
              <div
                key={e.key}
                onMouseDown={() => onChangeMode(e.key)}
                onClick={() => onChangeMode(e.key)}
                className={`button_big margin_right ${css_id}`}
              >
                {e.name}
              </div>
            );
          })}
        </section>
        <section
          style={{ maxHeight: "calc(100vh - 233px)", overflowY: "scroll" }}
        >
          {list_result}
        </section>
      </div>
    </ModalSearch>
  );

  const no_license_content = <RedeemPopup language={language} />;

  const modal_notification_content = modal_notification && (
    <ModalNotification
      modalSize="small"
      id="modal"
      isOpen={modal_notification}
      onClose={toggleNotification}
    >
      <div className="box-body">
        <NotificationList />
      </div>
    </ModalNotification>
  );

  const array_option = [
    {
      name: "Map Editor",
      icon: icon_map_editor,
      link:
        mode_search === "layer"
          ? `/editor/${project_selected.link}?layer_id=${layer_selected._id}`
          : `/editor/${project_selected.link}`,
    },
    {
      name: "Map Viewer",
      icon: icon_analyze_lite,
      link:
        mode_search === "layer"
          ? `/view/${project_selected.link}?layer_id=${layer_selected._id}`
          : `/view/${project_selected.link}`,
    },
    {
      name: "Form Editor",
      icon: icon_form,
      link: `/form_editor/${layer_selected.link}`,
    },
  ];

  const modal_project_content = modal_project && (
    <ModalSearch id="modal" isOpen={modal_project} onClose={toggleProject}>
      <div className="box-body" style={{ textAlign: "center" }}>
        {array_option.map((e, idx) => {
          if (idx !== 3 || (idx === 3 && mode_search === "layer")) {
            return (
              <Link key={e.name} to={e.link} onClick={closeSearch}>
                <div
                  style={{
                    textAlign: "center",
                    display: "inline-block",
                    width: "77px",
                    margin: "20px",
                    verticalAlign: "top",
                  }}
                >
                  <img
                    src={e.icon}
                    height="45px"
                    alt={e.name}
                    style={{ marginBottom: "10px" }}
                  />
                  <div className="text_bold" style={{ fontSize: "14px" }}>
                    {e.name}
                  </div>
                </div>
              </Link>
            );
          }
          return null;
        })}
      </div>
    </ModalSearch>
  );

  const language_list = [
    {
      name: "INA",
      value: "ina",
      image: "https://mapid.co.id/img/icon/indo-flag.png",
    },
    {
      name: "ENG",
      value: "eng",
      image: "https://mapid.co.id/img/icon/uk-flag.png",
    },
  ];

  const language_content = (
    <main style={{ marginTop: "10px" }}>
      {language_list.map((e) => {
        const css_id =
          e.value === language
            ? "outline_black grey_container"
            : "outline_grey grey_container";
        return (
          <div
            onClick={() => onSetLanguage(e.value)}
            key={e.value}
            className={`button_pill margin_right margin_bottom ${css_id}`}
            style={{ width: "35px" }}
          >
            <img
              style={{ width: "20px", height: "20px" }}
              src={e.image}
              alt={e.name}
            />
          </div>
        );
      })}
    </main>
  );

  const nav_content = (
    <main id="navbarDefault" className="navbarDefault">
      <section className="top_nav" id="top_nav">
        <div className="top_nav_container">
          <div
            className={`center_perfect gap_15 margin_x_5 ${width <= 900 ? "w_250" : "w_200"}`}
          >
            {width <= 900 && (
              <div
                onClick={toggle_is_menu_sidebar_open_func}
                className="w_30 h_30 pointer"
              >
                <img src={icon_hamburger} height="30px" alt={"menu"} />
              </div>
            )}
            <Link to="/dashboard">
              <div className="center_perfect">
                <img
                  src={domain_list?.[domain]?.logo_black}
                  height="30px"
                  alt={"icon"}
                />
              </div>
            </Link>
          </div>
          <div className="flex justify_end align_center gap_10 marginRight_20">
            {isAuthenticated && (
              <button
                className="button_big outline_grey button_white"
                onClick={activateSearch}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  width: is_mobile ? "99px" : "auto",
                  paddingLeft: "10px",
                }}
              >
                <img src={icon_search} width={"20px"} alt="Search" />
                <span className="margin_left">
                  {is_mobile
                    ? dict["Search"][language]
                    : dict["Search your layer, project or group"][language]}
                </span>
              </button>
            )}
            {isAuthenticated && (
              <div
                style={{ cursor: "pointer" }}
                onClick={toggleNotification}
                data-mapid="clickHome"
              >
                <img src={icon_notification} height="25px" alt="GEO MAPID" />
              </div>
            )}
          </div>
        </div>
      </section>

      <section
        className={`sidebar_home sidebar_dashboard_layout ${is_menu_sidebar_open || !is_mobile ? "open" : ""}`}
      >
        <div>
          {array_menu_final.map(
            ({ title, icon, link, links, button_mode, toggle_action }, idx) => {
              let content = (
                <Link
                  to={link}
                  onClick={() => {
                    if (width <= 900) toggle_is_menu_sidebar_open_func();
                  }}
                  className={`sidebar_button vertical_center w_200 ${links.includes(pathname) ? "background_grey_light" : "background_white"}`}
                  key={idx}
                  data-mapid={`clickButton-${idx}`}
                >
                  <div
                    className="vertical_center_child"
                    style={{ width: "100%" }}
                  >
                    <div style={{ marginLeft: "20px" }}>
                      <img src={icon} alt={title} width="35px" />
                    </div>
                    <div
                      className="text_medium"
                      style={{ marginLeft: "20px", width: "250px" }}
                    >
                      {title}
                    </div>
                  </div>
                </Link>
              );
              if (button_mode === "menu_expand") {
                content = (
                  <div
                    className={`sidebar_button vertical_center w_200 ${links.includes(pathname) ? "background_grey_light" : "background_white"}`}
                    onClick={toggle_action}
                  >
                    <div className="vertical_center_child">
                      <div style={{ marginLeft: "20px" }}>
                        <img src={icon} alt={title} width="35px" />
                      </div>
                      <div
                        className="text_medium"
                        style={{ marginLeft: "20px", width: "250px" }}
                      >
                        {title}
                      </div>
                    </div>
                  </div>
                );
              }
              return <div key={idx}>{content}</div>;
            },
          )}
          {premium_status === "basic" && no_license_content}
        </div>

        <div
          style={{ marginLeft: "20px", marginTop: "60px" }}
          className="text_medium"
        >
          {!is_login_kai ? (
            <div className="text_small sub_color margin_bottom">
              {" "}
              {domain_list?.[domain]?.short_title} V {version}{" "}
            </div>
          ) : (
            <div className="text_small sub_color margin_bottom">
              {domain_list?.[domain]?.short_title} Update: {last_update}
            </div>
          )}
          <br />
          {!is_login_kai && (
            <>
              <a
                className="button_small outline_grey button_white margin_right margin_bottom"
                href="https://mapid.co.id/releases"
                target="_blank"
                rel="noopener noreferrer"
              >
                {dict["What's New"][language]}
              </a>
              <a
                className="button_small outline_grey button_white"
                href={
                  env === "prod"
                    ? `https://mapid.co.id/docs/?language=${language}`
                    : `https://staging.mapid.co.id/docs/?language=${language}`
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                Docs
              </a>
            </>
          )}
          <div>{language_content}</div>
        </div>

        {isAuthenticated && (
          <div className="flex align_end">
            <div>
              <div className="paddingLeft_15 w_175">
                <hr />
              </div>
              <Link
                to={"/recovery"}
                onClick={() => {
                  if (width <= 900) toggle_is_menu_sidebar_open_func();
                }}
                className="sidebar_button vertical_center w_200"
                id={pathname === "/recovery" ? "active" : "not_active"}
                key={"Recovery"}
              >
                <div className="vertical_center_child">
                  <div style={{ marginLeft: "20px" }}>
                    <div className="bg_lightGrey rounded_full center_perfect w_35 h_35">
                      <img
                        src={icon_trash}
                        style={{ filter: "invert(1)" }}
                        alt={dict["Recovery"][language]}
                        width="20px"
                      />
                    </div>
                  </div>
                  <div
                    className="text_medium"
                    style={{ marginLeft: "20px", width: "250px" }}
                  >
                    {dict["Recovery"][language]}
                  </div>
                </div>
              </Link>
            </div>
          </div>
        )}
      </section>
    </main>
  );

  const modal_whatsapp_confirm = modal_whatsapp && (
    <>
      {is_confirmed ? (
        <ModalEmailConfirm
          modalSize="medium"
          id="modal"
          isOpen={modal_whatsapp}
          onClose={toggleWhatsappConfirm}
          auth={auth}
        >
          <WhatsappConfirm onClose={toggleWhatsappConfirm} />
        </ModalEmailConfirm>
      ) : null}
    </>
  );

  const modal_login_content = modal_login && (
    <Modal
      modalSize="small"
      id="modal"
      isOpen={modal_login}
      onClose={toggle_login}
    >
      <div className="box-body">
        {mode_auth === "login" ? (
          <Login isNav={true} />
        ) : (
          <Register isNav={true} />
        )}
        <section style={{ display: "block", marginTop: "30px" }}>
          <p className="button_account">
            {mode_auth === "login"
              ? dict["Don't have an account?"][language]
              : dict?.["Already have an account?"]?.[language]}
          </p>
          <p
            className="button_register"
            onClick={() =>
              set_mode_auth(mode_auth === "login" ? "register" : "login")
            }
          >
            {mode_auth === "login"
              ? dict["Register here"][language]
              : dict["Login instead"][language]}
          </p>
        </section>
        {language_content}
      </div>
    </Modal>
  );

  const modal_buy_license_content = modal_buy_license && (
    <Modal
      modalSize="medium"
      id="modal"
      isOpen={modal_buy_license}
      onClose={toggle_buy_license}
    >
      <div className="box-body">
        <div className="marginBottom_20">
          <label className="font_30 bold">
            {dict["Best license price for you"][language]}
          </label>
          <p>
            {
              dict[
                "Get features at the best price on the market! Limited time offer to boost your productivity."
              ][language]
            }
          </p>
        </div>
        <PaymentTable />
      </div>
    </Modal>
  );

  const path_wo_payment_popup = ["/login", "/register"];

  const modal_payment_universal_content = modal_payment_universal &&
    (user?.is_email_confirm !== "not_propose" ||
      user?.is_whatsapp_confirm !== "not_propose") &&
    !path_wo_payment_popup.includes(location.pathname) && (
      <Modal
        modalSize="large"
        id="modal"
        isOpen={modal_payment_universal}
        onClose={toggle_payment_universal}
      >
        <div className="box-body flex flex_col gap_10 h_full">
          <Pricing
            is_redirect={true}
            from="dashboard"
            create_payment={(payload) => dispatch(create_payment(payload))}
          />
        </div>
      </Modal>
    );

  const modal_block_license_universal_content =
    modal_block_license_universal && (
      <Modal
        modalSize="small"
        id="modal"
        isOpen={modal_block_license_universal}
        onClose={toggle_modal_block_license_universal}
      >
        <div className="box-body flex flex_col gap_10 h_full">
          <ErrorFreeKai from="Navigation.jsx" />
        </div>
      </Modal>
    );

  const modal_ketengan_content = modal_ketengan_universal && (
    <Modal
      modalSize="large"
      id="modal"
      isOpen={modal_ketengan_universal}
      onClose={toggle_modal_modal_ketengan_universal}
    >
      <div className="box-body flex flex_col gap_10 h_full">
        <PricingKetengan />
      </div>
    </Modal>
  );

  const modal_sini_ai_trial_content = modal_sini_ai_trial && (
    <Modal
      modalSize="small"
      is_hide="hide"
      backgroundColor="rgba(255, 255, 255, 1);"
      use_blur={false}
      blur_value="5px"
      borderRadius="30px"
      isOpen={modal_sini_ai_trial}
      onClose={toggle_sini_ai_trial}
    >
      <div
        className="box-body"
        id="box-body"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "400px",
          maxHeight: "75vh",
        }}
      >
        <main>
          <section style={{ textAlign: "center" }}>
            <h1>Redeem akses SINI AI trial berhasil!</h1>
            <br />
            <br />
            <br />
            <SINI_ILUSTRATION />
            <br />
            <br />
            <br />
            <Link to="/sini" className="button_big">
              Pakai sekarang
            </Link>
          </section>
        </main>
      </div>
    </Modal>
  );

  const modal_push_member_content = modal_push_member && (
    <Modal
      modalSize="medium"
      isOpen={modal_push_member}
      onClose={toggle_modal_push_member}
    >
      <div className="box-body">
        <PROJECT_COLLAB title="Pinned" />
      </div>
    </Modal>
  );

  return (
    <div>
      {modal_sini_ai_trial_content}
      {modal_buy_license_content}
      {modal_login_content}
      {modal_notification_content}
      {modal_project_content}
      {modal_whatsapp_confirm}
      {modal_payment_universal_content}
      {modal_block_license_universal_content}
      {modal_ketengan_content}
      {modal_push_member_content}
      {search_result_content}
      {nav_content}
    </div>
  );
};

export default Navigation;
